import TargetOrder from './targetOrder';
import { counties } from '@silvergatedelivery/constants';

const getDeliveryDatetime = (productName) => {
  const match = productName.match(/(\d{1,2})\/(\d{1,2})/);
  if (match) {
    const month = match[1];
    const day = match[2];
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const defaultTime = 'T09:00:00.000Z'; // TODO
    let isoDateString = `${currentYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')}${defaultTime}`;

    const sixMonthsAgo = new Date(currentDate);
    sixMonthsAgo.setMonth(currentDate.getMonth() - 6);
    if (new Date(isoDateString) < sixMonthsAgo) {
      isoDateString = `${currentYear + 1}-${month.padStart(2, '0')}-${day.padStart(2, '0')}${defaultTime}`;
    }
    return isoDateString;
  }
  return;
};

// Adapter for 家餚
export default class JiayaoAdapter extends TargetOrder {
  constructor(sourceData) {
    const sortedSourceData = sourceData.filter((data) => data['Order Name']).sort((a, b) => {
      const parseNumberFromHash = (inputString) => {
        if (!inputString) {
          return 0;
        }
        const stringWithoutHash = inputString.substring(1);
        const resultNumber = parseInt(stringWithoutHash, 10);
        return resultNumber;
      };
      const orderNameA = parseNumberFromHash(a['Order Name']);
      const orderNameB = parseNumberFromHash(b['Order Name']);
      const orderNumberA = parseNumberFromHash(b['Order Number']);
      const orderNumberB = parseNumberFromHash(b['Order Number']);
      if (orderNameA < orderNameB) {
        return -1;
      } else if (orderNameA > orderNameB) {
        return 1;
      }
      if (orderNumberA < orderNumberB) {
        return -1;
      }
      return 1;
    });
    let previousData = {};
    const orders = sortedSourceData.map((data) => {
      const orderName = data['Order Name'];
      const orderNumber = data['Order Number'];
      if (!orderNumber) {
        if (orderName !== previousData['Order Name']) {
          console.error(`unable to find order ${orderName}`);
        } else {
          const fieldsToCopy = ['Fulfillment First Name', 'Fulfillment Last Name', 'Fulfillment Province',
            'Fulfillment District', 'Fulfillment Address 1', 'Fulfillment Zipcode', 'Fulfillment Phone', 'Fulfillment Email', 'Remark',
            'Billing First Name', 'Billing Last Name', 'Billing Phone', 'Date',
          ];
          fieldsToCopy.forEach((key) => {
            data[key] = previousData[key];
          });
        }
      }
      const date = data['Date'];
      const deliveryDatetime = getDeliveryDatetime(data['Item Name']);
      const firstName = data['Fulfillment First Name'];
      const lastName = data['Fulfillment Last Name'];
      const county = data['Fulfillment Province'] && data['Fulfillment Province'].split(' ')[0];
      const district = data['Fulfillment District'];
      let street = data['Fulfillment Address 1'];
      const zipCode = data['Fulfillment Zipcode'];
      const phoneNumber = data['Fulfillment Phone'];
      const email = data['Fulfillment Email'];
      const name = data['Item Name'];
      const quantity = Number(data.Quantity);
      const price = Number(data['Item Price']) * quantity;
      const cost = Number(data['Item Price']) * quantity;
      const note = data['Item Properties'] + ', ' + data['Item Variant'];
      const noteForDelivery = data.Remark;
      const emergencyContact = {
        name: data['Billing Last Name'] + data['Billing First Name'],
        relationship: 'Billing',
        phoneNumber: data['Billing Phone'],
      };
      if (orderNumber) {
        previousData = data;
      }
      // workaournd: 家餚會有客人將county或district填到street
      const districtIndex = street.indexOf(district);
      if (districtIndex !== -1) {
        street = street.substring(districtIndex + district.length);
      }
      const filterCounties = [...counties, '台北市'].filter((county) => street.includes(county));
      filterCounties.forEach((county) => {
        street = street.replace(county, '');
      });
      return {
        // restaurantId,
        // elderId: elder.id,
        deliveryDatetimes: [deliveryDatetime],
        noteForDelivery,
        // noteForMeal: '',
        total: price,
        totalCost: cost,
        category: '送餐',
        mealItems: [{
          name,
          quantity,
          price,
          cost,
          note,
        }],
        // paymentMethod: '', // TODO
        referenceId: `jiayao-${orderName}-${date}`,
        source: 'web',
        elder: {
          username: 'N/A',
          status: '使用中',
          // clientId,
          county,
          name: `${lastName}${firstName}`,
          phoneNumber,
          address: {
            county,
            district,
            // lat, lng // TODO
            street,
            zipCode,
          },
          // isAllowedToEnterHome: 0,
          // isDisadvantaged: 0,
          email,
          emergencyContact,
        },
      };
    });

    super(orders, [], true, true);
  }
}
